import { render, staticRenderFns } from "./FormULA2.vue?vue&type=template&id=5f4d854e&scoped=true"
import script from "./FormULA2.vue?vue&type=script&lang=js"
export * from "./FormULA2.vue?vue&type=script&lang=js"
import style0 from "./FormULA2.vue?vue&type=style&index=0&id=5f4d854e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d854e",
  null
  
)

export default component.exports